// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1CGTK","col":"CardReaderDesc_col__2MSwT","label":"CardReaderDesc_label__gVr3Q"};